import { AudibleAlert, audibleAlerts } from './audible-alerts';

type EventAlert = Extract<AudibleAlert, { type: 'NEW_EVENT' | 'AED_ATTEMPTING_ACCEPTING' }>;

/** Sounds an event queue alert once per event, until the event leaves the queues. */
export class SoundAlertStore {
    private alertedTypesByEventId = new Map<number, Set<EventAlert['type']>>();

    /** An alert that had no sound doesn't count, so it can still sound for the event later. */
    playOnceForEvent(eventId: number, alert: EventAlert): void {
        let alertedTypes = this.alertedTypesByEventId.get(eventId);
        if (alertedTypes?.has(alert.type) || !audibleAlerts.playAlert(alert)) {
            return;
        }
        if (!alertedTypes) {
            alertedTypes = new Set();
            this.alertedTypesByEventId.set(eventId, alertedTypes);
        }
        alertedTypes.add(alert.type);
    }

    removeSoundForEvent(eventId: number): void {
        this.alertedTypesByEventId.delete(eventId);
    }
}

export const soundAlertStore = new SoundAlertStore();
